import React, { useState, useEffect } from "react";
import "./TenantWelcomeBannerMobile.scss";
import { FaPlay, FaTimes } from "react-icons/fa";
import { MdWavingHand, MdTouchApp } from "react-icons/md";

const TenantWelcomeBannerMobile = ({ userName, onStartTour, onDismiss }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Add a small delay for smooth animation
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  const handleStartTour = () => {
    setIsVisible(false);
    setTimeout(() => {
      onStartTour();
    }, 300);
  };

  const handleDismiss = () => {
    setIsVisible(false);
    setTimeout(() => {
      onDismiss();
    }, 300);
  };

  return (
    <div className={`tenant-welcome-banner-mobile ${isVisible ? "visible" : ""}`}>
      <div className="welcome-content-mobile">
        <div className="welcome-header-mobile">
          <div className="welcome-icon-mobile">
            <MdWavingHand />
          </div>
          <div className="welcome-text-mobile">
            <h3>Welcome, {userName}!</h3>
            <p>Ready to explore your payment dashboard?</p>
          </div>
          <button className="dismiss-btn-mobile" onClick={handleDismiss}>
            <FaTimes />
          </button>
        </div>
        
        <div className="welcome-body-mobile">
          <p>Take a quick tour to learn about:</p>
          <ul>
            <li>
              <MdTouchApp className="feature-icon" />
              Payment progress tracking
            </li>
            <li>
              <MdTouchApp className="feature-icon" />
              Quick payment links
            </li>
            <li>
              <MdTouchApp className="feature-icon" />
              Transaction history
            </li>
          </ul>
        </div>
        
        <div className="welcome-actions-mobile">
          <button className="tour-btn-mobile" onClick={handleStartTour}>
            <FaPlay />
            Start Tour
          </button>
          <button className="skip-btn-mobile" onClick={handleDismiss}>
            Skip
          </button>
        </div>
      </div>
    </div>
  );
};

export default TenantWelcomeBannerMobile;
